import { createContext, useState } from "react"

export interface KeyboxRotationContextType {
    isAllRotated?: boolean
    setIsAllRotated?: (isAllRotated: boolean) => void
}

export const KeyboxRotationContext = createContext<KeyboxRotationContextType>(
    {}
)

export const KeyboxRotationProvider = ({
    children
}: React.PropsWithChildren) => {
    const [isAllRotated, setIsAllRotated] = useState(false)
    return (
        <KeyboxRotationContext.Provider
            value={{ isAllRotated, setIsAllRotated }}
        >
            {children}
        </KeyboxRotationContext.Provider>
    )
}
